// QuickSight embed URL caching (used in useEmbedUrl and ReactQueryProvider)
export const EMBED_URL_CACHE_MS = 29 * 60 * 1000;
export const EMBED_URL_QUERY_KEY = ['dashboards', 'embedBaseUrl'] as const;

// Descriptions for dashboards (keyed by dashboard name)
export const DASHBOARD_DESCRIPTIONS: Record<string, string> = {
  Returns: 'Generate a report of returned items and reasons',
  'Stock on hand': 'View current stock levels across your products',
};

export const getDashboardDescription = (name: string): string => {
  return DASHBOARD_DESCRIPTIONS[name] ?? 'View and analyze your data';
};
